import { useSelector } from "react-redux";

const useSupporters = () => {
  const mainSettings = useSelector(
    (reduxStore) => reduxStore.appStore.mainSettings
  );

  const supporters = mainSettings?.fieldSupporters?.length
    ? mainSettings?.fieldSupporters
    : [];

  const isFestivalOverviewPage = useSelector(
    (reduxStore) => reduxStore.appStore.isFestivalOverviewPage
  );
  const isConferenceOverviewPage = useSelector(
    (reduxStore) => reduxStore.appStore.isConferenceOverviewPage
  );

  const showSupportersOnConferenceOverview =
      mainSettings.fieldSponsorsConferenceOvervi,
    showSupportersOnFestivalOverview =
      mainSettings.fieldSponsorsFestivalOverview;

  const isActive =
    (isFestivalOverviewPage && showSupportersOnFestivalOverview) ||
    (isConferenceOverviewPage && showSupportersOnConferenceOverview);

  return {
    supporters,
    isActive,
  };
};

export default useSupporters;
